import React from 'react';

export const Tip = ({ children }) => (
  <div style={{ textAlign: "center", color: "#888", fontSize: "0.9em" }}>
    <em>{children}</em>
  </div>
);

export const renderDateCell = (date) => (
  <span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
    {date}
  </span>
);